<template>
  <div class="" style="font-size: 16px; padding-top: 2px " v-if="display_style">
    <template v-for="predictRes in result">
      <p v-if="predictRes.prediction">
        <v-tooltip top>
          <span slot="activator">
            <span class="ref_sentence">{{predictRes.sentence}}</span>
            <span class="ref_mark">[...]</span>
          </span>
          <span>needs citation:&nbsp; <b>{{predictRes.prediction?'YES':'NO'}}</b><br> probability_0: {{(predictRes.probability_0).toFixed(5)}} <br> probability_1: {{(predictRes.probability_1).toFixed(5)}}</span>
        </v-tooltip>
      </p>
      <p v-else>
        <v-tooltip top>
          <span slot="activator">{{predictRes.sentence}}</span>
          <span>needs citation:&nbsp; <b>{{predictRes.prediction?'YES':'NO'}}</b><br> probability_0: {{(predictRes.probability_0).toFixed(5)}}<br> probability_1: {{(predictRes.probability_1).toFixed(5)}}</span>
        </v-tooltip>
      </p>
    </template>
  </div>
  <div class="" style="font-size: 16px;padding-top: 2px" v-else>
    <template v-for="predictRes in result">
      <span class="sentence" v-if="predictRes.prediction">
        <v-tooltip top>
          <span slot="activator"><span class="ref_sentence">{{predictRes.sentence}}</span><span
            class="ref_mark">[...]</span></span>
          <span>needs citation:&nbsp; <b>{{predictRes.prediction?'YES':'NO'}}</b><br> probability_0: {{(predictRes.probability_0).toFixed(5)}}<br> probability_1: {{(predictRes.probability_1).toFixed(5)}}</span>
        </v-tooltip>&nbsp;&nbsp;
      </span>
      <span class="sentence" v-else>
        <v-tooltip top>
          <span slot="activator">{{predictRes.sentence}}</span>
         <span>needs citation:&nbsp; <b>{{predictRes.prediction?'YES':'NO'}}</b><br>probability_0: {{(predictRes.probability_0).toFixed(5)}} <br> probability_1: {{(predictRes.probability_1).toFixed(5)}}</span>
          </v-tooltip>&nbsp;&nbsp;
      </span>
    </template>
  </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  span.sentence {
    margin-bottom: 10px;
  }

  .ref_sentence {
    background-color: #ddd;
  }

  .ref_mark {
    color: coral;
    font-size: medium;
    font-weight: bold;
  }

</style>


<script>
  export default {
    name: 'resultlist',
    props: ['display_style', 'result'],
    data: () => ({}),
    created: function () {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ResultList.vue